import { useFormSelector } from 'mrf/redux/ReduxHelper';
import { Col, Grid } from 'mrf/view/Grid';
import Report from 'mrf/view/Report';
import {useTranslation} from "react-i18next";
import dateFormatter from 'mrf/utils/DateFormatter';
import DateField from 'mrf/view/DateField';
import FetcherObjectSelect from 'mrf/view/FetcherObjectSelect';

export default function CommunicationAssignmentsReport({ history, match }) {

    const context = useFormSelector({
        resource: 'communicationAssignmentsReport',
    });

    const {t} = useTranslation();

    const assignmentStatusFormatter = (t) => (value) => (
    {
        0: t('Open'),
        1: t('Done'),
        2: t('Canceled'),
        3: t('AutoClosed'),
    }[value] ?? value);

    const tableFields = [
        {name: t('Responsible'), keys: ['communicationCountry','institution','country', 'name']},
        {name: t('Required Action'), keys: ['requiredAction','name'], map:t},
        {name: t('Status'), key: ['status'], map: assignmentStatusFormatter(t),},
        { name: t('Created at'), key: 'createdAt', map: dateFormatter },
        {name: t('Transfer Code'), keys: ['communicationEvent','communicationProcessId']},
    ];

    const fields = [{ name: t('Name'), key: 'name'}];

    return <Report
        match={match}
        context={context}
        history={history}
        title={t('Communication Assignments Report')}
        tableFields={tableFields}
    >
        <Grid>
            <Col size={6}>
                <DateField
                    label={t('Start Date')}
                    field='startDate'
                />
            </Col>
            <Col size={6}>
                <DateField
                    label={t('Finish Date')}
                    field='finishDate'
                />
            </Col>
            <Col size={4}>
                <FetcherObjectSelect
                    label={t('Responsible')}
                    resource='countries'
                    field='countryId'
                    displayAttribute='name'
                    fields= {fields}
                />
            </Col>
            <Col size={4}>
                <FetcherObjectSelect
                    label={t('Required Action')}
                    field='requiredActionId'
                    resource='communicationAssignmentRequiredActions'
                    displayAttribute='name'
                    fields= {fields}
                />
            </Col>
            <Col size={4}>
                <FetcherObjectSelect
                    label={t('Status')}
                    resource='communicationAssignments/status'
                    field='status'
                    displayAttribute='name'
                    fields= {fields}
                />
            </Col>
        </Grid>
    </Report>
}